import { Box, Paper, Typography } from "@mui/material";
import React from "react";
import TransmittedDocCard from "./Card";
import ActionsBtns from "./ActionsBtns";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { docsColumns } from "../../../../../../Vendor/VendorDocTransmittal/columns";
import { lightTable } from "../../../../../../../styles/muiProps";

export default function DocTransmittalSubRow({ row }) {
  const table = useMaterialReactTable({
    data: row?.documents || [],
    columns: docsColumns("dashboard"),
    ...lightTable,
  });

  return (
    <Box>
      <Paper sx={{ m: 1, p: 2 }}>
        <Typography variant="h6">Transmitted Documents: </Typography>

        {row?.documents?.length > 0 ? (
          <MaterialReactTable table={table} />
        ) : (
          // <Box>
          //   <Box sx={{ display: "flex", flexWrap: "wrap", mt: 1 }}>
          //     {row.documents.map((doc) => (
          //       <TransmittedDocCard row={row} doc={doc} />
          //     ))}
          //   </Box>

          //   <ActionsBtns row={row} />
          // </Box>
          <Typography
            sx={{
              m: 2,
              textAlign: "center",
              color: "gray",
              fontStyle: "italic",
            }}
          >
            No documents transmitted
          </Typography>
        )}
      </Paper>
    </Box>
  );
}
